import Swiper from "swiper/bundle";

const swiperPricing = new Swiper(".pricing-block_list", {
  slidesPerView: "auto",
  //   direction: "horizontal",
  spaceBetween: 30,
  freeMode: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
